import {locationCashierTheme} from "utils/helper-functions/get-url-vars";

export const isPanoramicTheme = locationCashierTheme === 'panoramic-2-0-theme'
// export const isPanoramicTheme = true
